import { Col } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { wrapper } from './WhatMakesSubscription.css';

export const WhatMakesSubscription = () => (
  <div className={wrapper}>
    <Typography variant="headline" size="large">
      What makes a fantastic Subscription?
    </Typography>
    <Col gap="xl">
      <Typography variant="body" size="large">
        We've got all the guidelines you need so that you know exactly how much
        content to create ahead of selling.
      </Typography>
    </Col>
    <iframe
      src="https://www.loom.com/embed/331973cd17554ecb8a492a121e79e5bb?sid=b8953b6f-fadf-41ca-9f1c-4714c3bec29b"
      className="bg-black w-full h-[200px] md:w-[700px] md:h-[360px] rounded-[20px]"
    ></iframe>
  </div>
);
